import { FadeIn } from 'components/common/FadeIn';
import Apple from '../../../svg/PaymentLogos/apple.svg';
import Google from '../../../svg/PaymentLogos/google.svg';
import Mastercard from '../../../svg/PaymentLogos/mastercard.svg';
import Paypal from '../../../svg/PaymentLogos/paypal.svg';
import Visa from '../../../svg/PaymentLogos/visa.svg';
import styles from './footer.module.css';

export const PaymentLogos = () => {
  return (
    <div className={styles.paymentLogos}>
      <FadeIn onScroll>
        <Paypal />
      </FadeIn>
      <FadeIn onScroll delay={0.05}>
        <Google />
      </FadeIn>
      <FadeIn onScroll delay={0.1}>
        <Apple />
      </FadeIn>
      <FadeIn onScroll delay={0.15}>
        <Visa />
      </FadeIn>
      <FadeIn onScroll delay={0.2}>
        <Mastercard />
      </FadeIn>
    </div>
  );
};
